import * as $ from "jquery";

export default class BoostsEditComponent {
    constructor() {
        this.componentSelector = "#boostplan-edit";
        this.instance = this;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;

        // Multiselect: Marknader (custom checkbox-dropdown)
        (function () {
            var $root = $('#market-ms');
            if ($root.length === 0) return;

            var $toggle = $root.find('.ms-toggle');
            var $menu = $root.find('.ms-menu');
            var $cbs = $root.find('input[type="checkbox"]');

            function updateLabel() {
                var labels = [];
                $cbs.each(function () {
                    if (this.checked) {
                        labels.push($(this).closest('label').text().trim());
                    }
                });
                $toggle.text(labels.length ? labels.join(', ') : 'Välj marknad(er)');
            }

            $toggle.off('click.marketms').on('click.marketms', function (e) {
                e.stopPropagation();
                $menu.toggleClass('open');
            });

            $(document).off('click.marketms').on('click.marketms', function (e) {
                if ($(e.target).closest('#market-ms').length === 0) {
                    $menu.removeClass('open');
                }
            });

            $cbs.off('change.marketms').on('change.marketms', function () {
                updateLabel();
            });

            updateLabel();
        })();

        $('#boostplan-save').off().on('click', function () {
            instance.save();
        });

        $('#boostplan-cancel').off().on('click', function () {
            window.location.href = '/boosts';
        });

        $('#boostplan-delete').off().on('click', function () {
            instance.delete();
        });

        $('.item-delete').off().on('click', function () {
            instance.deleteItem(instance, this);
        });

        $('.toggle-btn').on('click', function () {
            $('.toggle-btn').removeClass('active');
            $(this).addClass('active');

            var target = $(this).data('target');
            $('.toggle-panel').hide();
            $('.toggle-panel').removeClass('hidden');
            $(target).fadeIn(150);
        });
    }

    deleteItem(instance, e) {
        var sku = $(e).parent().attr('data-sku');
        bootbox.confirm('Vill du ta bort artikel ' + sku, function (result) {
            if (result)
                $(e).parent().remove();
        });
    }

    save(instance) {
        let id = $('#boostplan-edit').attr('data-id');
        //let marketId = $('#market').val();

        // Multiselect: hämta valda marknader (checkboxar)
        var marketIds = $('#market-ms input[name="MarketIds"]:checked').map(function () {
            return parseInt($(this).val(), 10);
        }).get();

        if (marketIds.length == 0) {
            bootbox.alert('Du måste välja minst en marknad');
            return;
        }

        let active = 1;
        let boostType = $('.toggle-btn.active').attr('data-boosttype');
        let boostKey = "";
        let startDate = $('#startdate').val();
        let endDate = $('#enddate').val();
        let name = $('#name').val();
        let description = $('#description').val();
        let boostFactor = 10;
        let skus = []

        if (id === "-1") {
            skus = document.getElementById('skulist').value
                .split('\n')
                .map(s => s.trim())
                .filter(s => s.length);
        }
        else {
            $.each($(".item-row"), function () {
                let sku = $(this).attr('data-sku');
                skus.push(sku);
            });

            let textboxSkus = document.getElementById('skulist').value
                .split('\n')
                .map(s => s.trim())
                .filter(s => s.length);
            skus.push(...textboxSkus);
        }

        if (boostType == 1) {
            boostKey = $('#category').val();
        }

        if (boostType == 2) {
            boostKey = $('#brand').val();
        }

        if (boostType == 3) {
            boostKey = $('#discount').val();
        }

        $('#boostplan-edit').css('opacity', '0.4');

        axios({
            method: 'post',
            url: "/boost/save",
            data: { id: id, marketIds: marketIds, active: active, boostType: boostType, boostKey: boostKey, startDate: startDate, endDate: endDate, name: name, description: description, boostFactor: boostFactor, skus: skus }
        }).then(function (response) {
            $('#boostplan-edit').css('opacity', '1.0');
            window.location.reload();
        }).catch(function (response) {
            console.log(response);
        });
    }

    delete(instance) {
        bootbox.confirm('Vill du ta bort boostplanen? Det kan inte ångras.', function (result) {
            let id = $('#boostplan-edit').attr('data-id');
            axios({
                method: 'post',
                url: "/boost/delete",
                data: { id: id }
            }).then(function (response) {
                $('#boostplan-edit').css('opacity', '1.0');
                window.location.href = "/boosts";
            }).catch(function (response) {
                console.log(response);
            });
        });
    }
}